import { render, staticRenderFns } from "./FormAccountName.vue?vue&type=template&id=cb527ae2&scoped=true&"
import script from "./FormAccountName.vue?vue&type=script&lang=ts&"
export * from "./FormAccountName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb527ae2",
  null
  
)

export default component.exports